module.exports = __webpack_public_path__ + "img/wall_02.png";